export enum ScopeCategoryEnum {
  BASIC = 'BASIC',
  ADVANCED = 'ADVANCED',
  TRIAL = 'TRIAL',
  ENTERPRISE = 'ENTERPRISE',
}
